<template>
  <v-icon>
    {{ svgPath }}
  </v-icon>
</template>

<script>
import { mdiAccountConvert } from "@mdi/js";
export default {
  name: "MdiAccountConvert",
  data() {
    return {
      svgPath: mdiAccountConvert,
    };
  },
};
</script>
